/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createOneBaseMgmtEvaFoamControllerEvaFoam } from '../fn/eva-foam/create-one-base-mgmt-eva-foam-controller-eva-foam';
import { CreateOneBaseMgmtEvaFoamControllerEvaFoam$Params } from '../fn/eva-foam/create-one-base-mgmt-eva-foam-controller-eva-foam';
import { createOneBaseMgmtShoreControllerShore } from '../fn/eva-foam/create-one-base-mgmt-shore-controller-shore';
import { CreateOneBaseMgmtShoreControllerShore$Params } from '../fn/eva-foam/create-one-base-mgmt-shore-controller-shore';
import { deleteOneBaseMgmtEvaFoamControllerEvaFoam } from '../fn/eva-foam/delete-one-base-mgmt-eva-foam-controller-eva-foam';
import { DeleteOneBaseMgmtEvaFoamControllerEvaFoam$Params } from '../fn/eva-foam/delete-one-base-mgmt-eva-foam-controller-eva-foam';
import { deleteOneBaseMgmtShoreControllerShore } from '../fn/eva-foam/delete-one-base-mgmt-shore-controller-shore';
import { DeleteOneBaseMgmtShoreControllerShore$Params } from '../fn/eva-foam/delete-one-base-mgmt-shore-controller-shore';
import { EvaFoam } from '../models/eva-foam';
import { getManyBaseMgmtEvaFoamControllerEvaFoam } from '../fn/eva-foam/get-many-base-mgmt-eva-foam-controller-eva-foam';
import { GetManyBaseMgmtEvaFoamControllerEvaFoam$Params } from '../fn/eva-foam/get-many-base-mgmt-eva-foam-controller-eva-foam';
import { getManyBaseMgmtShoreControllerShore } from '../fn/eva-foam/get-many-base-mgmt-shore-controller-shore';
import { GetManyBaseMgmtShoreControllerShore$Params } from '../fn/eva-foam/get-many-base-mgmt-shore-controller-shore';
import { GetManyEvaFoamResponseDto } from '../models/get-many-eva-foam-response-dto';
import { GetManyShoreResponseDto } from '../models/get-many-shore-response-dto';
import { getOneBaseMgmtEvaFoamControllerEvaFoam } from '../fn/eva-foam/get-one-base-mgmt-eva-foam-controller-eva-foam';
import { GetOneBaseMgmtEvaFoamControllerEvaFoam$Params } from '../fn/eva-foam/get-one-base-mgmt-eva-foam-controller-eva-foam';
import { getOneBaseMgmtShoreControllerShore } from '../fn/eva-foam/get-one-base-mgmt-shore-controller-shore';
import { GetOneBaseMgmtShoreControllerShore$Params } from '../fn/eva-foam/get-one-base-mgmt-shore-controller-shore';
import { Shore } from '../models/shore';
import { updateOneBaseMgmtEvaFoamControllerEvaFoam } from '../fn/eva-foam/update-one-base-mgmt-eva-foam-controller-eva-foam';
import { UpdateOneBaseMgmtEvaFoamControllerEvaFoam$Params } from '../fn/eva-foam/update-one-base-mgmt-eva-foam-controller-eva-foam';
import { updateOneBaseMgmtShoreControllerShore } from '../fn/eva-foam/update-one-base-mgmt-shore-controller-shore';
import { UpdateOneBaseMgmtShoreControllerShore$Params } from '../fn/eva-foam/update-one-base-mgmt-shore-controller-shore';

@Injectable({ providedIn: 'root' })
export class EvaFoamApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getManyBaseMgmtEvaFoamControllerEvaFoam()` */
  static readonly GetManyBaseMgmtEvaFoamControllerEvaFoamPath = '/api/mgmt/eva-foam';

  /**
   * Retrieve multiple EvaFoams.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtEvaFoamControllerEvaFoam()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtEvaFoamControllerEvaFoam$Response(params?: GetManyBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyEvaFoamResponseDto>> {
    const obs = getManyBaseMgmtEvaFoamControllerEvaFoam(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple EvaFoams.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtEvaFoamControllerEvaFoam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtEvaFoamControllerEvaFoam(params?: GetManyBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<GetManyEvaFoamResponseDto> {
    const resp = this.getManyBaseMgmtEvaFoamControllerEvaFoam$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyEvaFoamResponseDto>): GetManyEvaFoamResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtEvaFoamControllerEvaFoam()` */
  static readonly CreateOneBaseMgmtEvaFoamControllerEvaFoamPath = '/api/mgmt/eva-foam';

  /**
   * Create a single EvaFoam.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtEvaFoamControllerEvaFoam()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOneBaseMgmtEvaFoamControllerEvaFoam$Response(params: CreateOneBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<StrictHttpResponse<EvaFoam>> {
    const obs = createOneBaseMgmtEvaFoamControllerEvaFoam(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single EvaFoam.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtEvaFoamControllerEvaFoam$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOneBaseMgmtEvaFoamControllerEvaFoam(params: CreateOneBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<EvaFoam> {
    const resp = this.createOneBaseMgmtEvaFoamControllerEvaFoam$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EvaFoam>): EvaFoam => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtEvaFoamControllerEvaFoam()` */
  static readonly GetOneBaseMgmtEvaFoamControllerEvaFoamPath = '/api/mgmt/eva-foam/{id}';

  /**
   * Retrieve a single EvaFoam.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtEvaFoamControllerEvaFoam()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtEvaFoamControllerEvaFoam$Response(params: GetOneBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<StrictHttpResponse<EvaFoam>> {
    const obs = getOneBaseMgmtEvaFoamControllerEvaFoam(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single EvaFoam.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtEvaFoamControllerEvaFoam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtEvaFoamControllerEvaFoam(params: GetOneBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<EvaFoam> {
    const resp = this.getOneBaseMgmtEvaFoamControllerEvaFoam$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EvaFoam>): EvaFoam => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtEvaFoamControllerEvaFoam()` */
  static readonly DeleteOneBaseMgmtEvaFoamControllerEvaFoamPath = '/api/mgmt/eva-foam/{id}';

  /**
   * Delete a single EvaFoam.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtEvaFoamControllerEvaFoam()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtEvaFoamControllerEvaFoam$Response(params: DeleteOneBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtEvaFoamControllerEvaFoam(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single EvaFoam.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtEvaFoamControllerEvaFoam$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtEvaFoamControllerEvaFoam(params: DeleteOneBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtEvaFoamControllerEvaFoam$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtEvaFoamControllerEvaFoam()` */
  static readonly UpdateOneBaseMgmtEvaFoamControllerEvaFoamPath = '/api/mgmt/eva-foam/{id}';

  /**
   * Update a single EvaFoam.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtEvaFoamControllerEvaFoam()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtEvaFoamControllerEvaFoam$Response(params: UpdateOneBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<StrictHttpResponse<EvaFoam>> {
    const obs = updateOneBaseMgmtEvaFoamControllerEvaFoam(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single EvaFoam.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtEvaFoamControllerEvaFoam$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  updateOneBaseMgmtEvaFoamControllerEvaFoam(params: UpdateOneBaseMgmtEvaFoamControllerEvaFoam$Params, context?: HttpContext): Observable<EvaFoam> {
    const resp = this.updateOneBaseMgmtEvaFoamControllerEvaFoam$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<EvaFoam>): EvaFoam => r.body)
    );
  }

  /** Path part for operation `getManyBaseMgmtShoreControllerShore()` */
  static readonly GetManyBaseMgmtShoreControllerShorePath = '/api/mgmt/shore';

  /**
   * Retrieve multiple Shores.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getManyBaseMgmtShoreControllerShore()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtShoreControllerShore$Response(params?: GetManyBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<StrictHttpResponse<GetManyShoreResponseDto>> {
    const obs = getManyBaseMgmtShoreControllerShore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve multiple Shores.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getManyBaseMgmtShoreControllerShore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getManyBaseMgmtShoreControllerShore(params?: GetManyBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<GetManyShoreResponseDto> {
    const resp = this.getManyBaseMgmtShoreControllerShore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<GetManyShoreResponseDto>): GetManyShoreResponseDto => r.body)
    );
  }

  /** Path part for operation `createOneBaseMgmtShoreControllerShore()` */
  static readonly CreateOneBaseMgmtShoreControllerShorePath = '/api/mgmt/shore';

  /**
   * Create a single Shore.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOneBaseMgmtShoreControllerShore()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtShoreControllerShore$Response(params: CreateOneBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<StrictHttpResponse<Shore>> {
    const obs = createOneBaseMgmtShoreControllerShore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Create a single Shore.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOneBaseMgmtShoreControllerShore$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOneBaseMgmtShoreControllerShore(params: CreateOneBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<Shore> {
    const resp = this.createOneBaseMgmtShoreControllerShore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Shore>): Shore => r.body)
    );
  }

  /** Path part for operation `getOneBaseMgmtShoreControllerShore()` */
  static readonly GetOneBaseMgmtShoreControllerShorePath = '/api/mgmt/shore/{id}';

  /**
   * Retrieve a single Shore.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOneBaseMgmtShoreControllerShore()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtShoreControllerShore$Response(params: GetOneBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<StrictHttpResponse<Shore>> {
    const obs = getOneBaseMgmtShoreControllerShore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Retrieve a single Shore.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOneBaseMgmtShoreControllerShore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOneBaseMgmtShoreControllerShore(params: GetOneBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<Shore> {
    const resp = this.getOneBaseMgmtShoreControllerShore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Shore>): Shore => r.body)
    );
  }

  /** Path part for operation `deleteOneBaseMgmtShoreControllerShore()` */
  static readonly DeleteOneBaseMgmtShoreControllerShorePath = '/api/mgmt/shore/{id}';

  /**
   * Delete a single Shore.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOneBaseMgmtShoreControllerShore()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtShoreControllerShore$Response(params: DeleteOneBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteOneBaseMgmtShoreControllerShore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Delete a single Shore.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOneBaseMgmtShoreControllerShore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOneBaseMgmtShoreControllerShore(params: DeleteOneBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteOneBaseMgmtShoreControllerShore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOneBaseMgmtShoreControllerShore()` */
  static readonly UpdateOneBaseMgmtShoreControllerShorePath = '/api/mgmt/shore/{id}';

  /**
   * Update a single Shore.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOneBaseMgmtShoreControllerShore()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtShoreControllerShore$Response(params: UpdateOneBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<StrictHttpResponse<Shore>> {
    const obs = updateOneBaseMgmtShoreControllerShore(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Update a single Shore.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOneBaseMgmtShoreControllerShore$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOneBaseMgmtShoreControllerShore(params: UpdateOneBaseMgmtShoreControllerShore$Params, context?: HttpContext): Observable<Shore> {
    const resp = this.updateOneBaseMgmtShoreControllerShore$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Shore>): Shore => r.body)
    );
  }

}
